<template>
  <div id="app">
    <auth-layout v-if="isPublic"></auth-layout>
    <div class="admin-container" v-else>
      <Sidebar :navItems="navigation"/>
      <div id="right-panel" class="right-panel">
        <Header />
        <div class="container-fluid p-4">
          <transition enter-active-class="animated fadeIn">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navMerani from './nav/navMerani'
import navInspirador from './nav/navInspirador'
import navAdmin from './nav/navAdmin'
import Header from './components/Header.vue'
import Sidebar from './components/Sidebar.vue'
import AuthLayout from './layouts/AuthLayout.vue'
import { mapState } from 'vuex'

export default {
  components: {
    AuthLayout,
    Header,
    Sidebar
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    isPublic () {
      return this.$route.path.match('auth') || this.$route.path.match('pub') || this.$route.path.match('shared')
    },
    navigation () {
      switch (String(this.user.rol).toLowerCase()) {
        case 'merani':
          return navMerani.items
        case 'inspirador':
          return navInspirador.items
        case 'admin':
          return navAdmin.items
        default:
          return []
      }
    },
    ...mapState('user', [
      'user'
    ])
  }
}
</script>

<style lang="scss">
@import "./assets/scss/variables.scss";

@import "./assets/scss/_gauge.scss";
@import "./assets/scss/_switches.scss";
@import "./assets/scss/_widgets.scss";
@import "~animate.css";

@import "vue-select/src/scss/vue-select.scss";
@import "./assets/scss/style.scss";

button {
    cursor: pointer;
}

.spinner {
    width: 80px;
    height: 80px;
    border: 2px solid #f3f3f3;
    border-top:3px solid #673a82;
    border-radius: 100%;
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right: 0;
    margin: auto;
    animation: spin 1s infinite linear;
}

@keyframes spin {
    from{
        transform: rotate(0deg);
    }to{
        transform: rotate(360deg);
    }
}
</style>
